import LoanStatusWrapper from '../pages/lendtech/LoanStatusWrapper';
import CashBackDetailsPage from '../pages/lendtech/cashBack/CashBackDetailsPage';
import CashBackTransactionLogsPage from '../pages/lendtech/cashBack/CashBackTransactionLogsPage';
import BankPaymentDetail from '../pages/lendtech/receiveCredit/BankPaymentDetail/BankPaymentDetail';
import LoanPaymentDetail from '../pages/lendtech/receiveCredit/LoanPaymentDetail/LoanPaymentDetailPage';
import InstallmentCardToCardGatewayPage from '../pages/lendtech/receiveCredit/installmentPaymentGateway/InstallmentCardToCardGatewayPage';
import InstallmentPaymentGatewayPage from '../pages/lendtech/receiveCredit/installmentPaymentGateway/InstallmentPaymentGatewayPage';
import TransactionReport from '../pages/lendtech/receiveCredit/installmentPaymentGateway/PaymentFinishedStatusPage';
import PendingInstallmentCardToCardPage from '../pages/lendtech/receiveCredit/installmentPaymentGateway/PendingInstallmentCardToCardPage';
import IsValidatingPage from '../pages/lendtech/receiveCredit/isValidating/IsValidatingPage';
import LoanPaymentCalculator from '../pages/lendtech/receiveCredit/loan-payment-calculator';
import NotPaidLoanDetailsPage from '../pages/lendtech/receiveCredit/notPaidLoanDetails/NotPaidLoanDetailsPage';
import RejectLoanRequestPage from '../pages/lendtech/receiveCredit/rejectLoanRequest/RejectLoanRequestPage';
import SignContractPage from '../pages/lendtech/receiveCredit/signcontract/SignContractPage';
import ValidationPage from '../pages/lendtech/receiveCredit/step1-validation/ValidationPage';
import ValidationDetailPage from '../pages/lendtech/receiveCredit/step1-validation/status3/validationDetail/ValidationDetailPage';
import SelectLoanPage from '../pages/lendtech/receiveCredit/step2-selectLoan/SelectLoanPage';
import LoanDocsPage from '../pages/lendtech/receiveCredit/step3-completeDocs/credit-loan/LoanDocsPage';
import type {AppRouteConfig} from './route.types';

export const receiveCreditRoutes: AppRouteConfig[] = [
  {path: 'loan-payment-calculator', element: LoanPaymentCalculator},
  {
    path: 'receive-credit',
    element: LoanStatusWrapper,
    children: [
      {path: 'step-1', element: ValidationPage},
      {
        path: 'step-1/validation-detail/:loanGuid',
        element: ValidationDetailPage,
      },
      {path: 'step-2', element: SelectLoanPage},
      {path: 'step-3', element: LoanDocsPage},
      {path: 'step-4', element: SignContractPage},
      {path: 'step-5', element: IsValidatingPage},
      {path: 'step-6', element: RejectLoanRequestPage},
    ],
  },
  {
    path: 'loan-payment-details/:loanGuid/:isPaid',
    element: LoanPaymentDetail,
  },
  {
    path: 'loan-payment-details/:loanGuid/isBank',
    element: BankPaymentDetail,
  },
  {path: 'not-paid-loan-details/:loanGuid', element: NotPaidLoanDetailsPage},
  // Cash Back
  {
    path: 'cash-back-details/:cashBackGuid',
    element: CashBackDetailsPage,
  },
  {
    path: 'cash-back-transaction-logs/:cashBackGuid',
    element: CashBackTransactionLogsPage,
  },
  // payment method gateway
  {
    path: 'installment-payment-gateway',
    element: InstallmentPaymentGatewayPage,
  },
  // card to card gateway
  {
    path: 'installment-card-to-card-pay',
    element: InstallmentCardToCardGatewayPage,
  },
  {
    path: 'installment-card-to-card-pay/pending',
    element: PendingInstallmentCardToCardPage,
  },
  {
    path: 'loan-validation-request-report',
    element: TransactionReport,
    props: {fallbackRoute: '/receive-credit/step-1'},
  },
];
